import React, { useState, useEffect } from 'react';
import ReactResizeDetector from 'react-resize-detector';
import { isValid, format, setSeconds, setMinutes, setHours } from 'date-fns';

// Components
import { Card, TextField, InputAdornment, ButtonGroup, Button, Typography } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import ContentHeader from '../../components/ContentHeader/ContentHeader';
import ThermalItem from '../../components/ThermalItem';
import TempGraph from '../BI/temperatureComponent/temperature';
import ThermalCarousel from '../../components/ThermalCarousel';

import { feverColor } from '../../shared/temperature-color';
import axios from '../../config/axiosInstance';

export default function () {
  const [selectedItem, setSelectItem] = useState(null);
  const [searchValue, setSearchValue] = useState('');
  const [list, setList] = useState([]);

  const types = [
    {
      id: 0,
      name: 'Todos',
    },
    {
      id: 1,
      name: 'Febre',
    },
    {
      id: 2,
      name: 'Sem EPI',
    },
  ];
  const [filterType, setFilterType] = useState(types[0]);

  const formatDate = dt => format(dt, 'yyyy-MM-dd HH:mm:ss');

  const getHighestTemp = details => [...details]
    .sort((a, b) => (a.temperature > b.temperature ? -1 : 1))[0];

  const fetchData = (period) => {
    let searchPeriod = period;

    if (!period) {
      const date = new Date();
      let dtFrom = setSeconds(date, 0);
      dtFrom = setMinutes(dtFrom, 0);
      dtFrom = setHours(dtFrom, 0);
      dtFrom = formatDate(dtFrom);

      let dtTo = setSeconds(date, 59);
      dtTo = setMinutes(dtTo, 59);
      dtTo = setHours(dtTo, 23);
      dtTo = formatDate(dtTo);

      searchPeriod = {
        dtFrom,
        dtTo,
      };
    }

    axios.post('timeSheet/generate/pointSheet/dahsboard/facialRecognition', searchPeriod)
      .then(({ data }) => {
        setList(data);
      })
      .catch(error => console.log(error));
  };

  const onDateChange = (date) => {
    if (isValid(date)) {
      let dtFrom = setSeconds(date, 0);
      dtFrom = setMinutes(dtFrom, 0);
      dtFrom = setHours(dtFrom, 0);
      dtFrom = formatDate(dtFrom);

      let dtTo = setSeconds(date, 59);
      dtTo = setMinutes(dtTo, 59);
      dtTo = setHours(dtTo, 23);
      dtTo = formatDate(dtTo);

      const searchPeriod = {
        dtFrom,
        dtTo,
      };

      fetchData(searchPeriod);
    }
  };

  useEffect(fetchData, []);

  const handleInputChange = (event) => {
    setSearchValue(event.target.value);
  };

  const isFilterSelected = type => filterType.name === type.name;

  const calcSize = (width) => {
    const nItems = Math.floor(width / (150 + 40));
    let widthPercentage = 100 / nItems;

    if (list.length < nItems) {
      widthPercentage = 100 / list.length;
      // widthPercentage = widthPercentage > 15 ? 15 : widthPercentage;
      if ((widthPercentage / 100) * width > 180) {
        return '180px';
      }
    }

    return `${widthPercentage}%`;
  };

  const filterItems = () => {
    let items = [...list];

    if (filterType.id === 0) {
      items = [...list];
    }

    if (filterType.id === 1) {
      items = list.filter(m => m.details[0].feverType === 1 || m.details[0].feverType === 2);
    }

    if (filterType.id === 2) {
      items = list.filter(m => m.details[0].noPPE === true);
    }

    return items.filter(item => item.name.toUpperCase().includes(searchValue.toUpperCase()));
    // return items;
  };

  return (
    <>
      <ContentHeader
        title="Câmera Térmica"
        subtitle="Acompanhe os funcionários que foram analisados pela câmera térmica"
      />

      <TempGraph notDash onDateChange={onDateChange} />

      <Card style={{ padding: '25px', marginTop: '20px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <TextField
            value={searchValue}
            style={{ flexBasis: '40%' }}
            onChange={handleInputChange}
            placeholder="Buscar"
            type="text"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon color="disabled" />
                </InputAdornment>
              ),
            }}
          />

          <ButtonGroup
            color="primary"
            aria-label="outlined primary button group"
            style={{ alignSelft: 'flex-end' }}
          >
            {types.map(type => (
              <Button
                onClick={() => setFilterType(type)}
                style={{
                  backgroundColor: isFilterSelected(type) ? '#537CCD' : 'white',
                  color: isFilterSelected(type) ? 'white' : '#537CCD',
                }}
              >
                {type.name}
              </Button>
            ))}
          </ButtonGroup>
        </div>

        {
          filterItems().length ? (
            <ReactResizeDetector handleWidth handleHeight>
              {({ width, height }) => (
                <div
                  style={{
                    display: 'flex', flexWrap: 'wrap', width: '100%', marginTop: '48px',
                  }}
                >
                  {
                    filterItems().map(item => (
                      <ThermalItem
                        name={item.name}
                        width={calcSize(width)}
                        ItemWithHighestTemp={getHighestTemp(item.details)}
                        color={feverColor(getHighestTemp(item.details).feverType)}
                        onClick={() => setSelectItem(item)}
                      />
                    ))
                  }
                </div>
              )}
            </ReactResizeDetector>
          ) : (
            <Typography align="center" style={{ margin: '24px' }}>Nenhuma informação encontrada</Typography>
          )
        }

        <ThermalCarousel
          open={selectedItem !== null}
          onClose={() => setSelectItem(null)}
          name={selectedItem && selectedItem.name}
          details={selectedItem && selectedItem.details}
        />
      </Card>
    </>
  );
}
